const bahasa = {
	lang: "BM",
	back: "Kembali",
	backDesc: "Kembali ke senarai negeri",
	tazkirahDesc: [
		`"Berilah khabar gembira kepada orang-orang yang berjalan di dalam
		kegelapan malam menuju masjid dengan cahaya yang akan diperolehnya pada
		hari kiamat." (HR. Abu Daud)"`,
		`tazkirah-bm-2`,
		`tazkirah-bm-3`,
		`tazkirah-bm-4`,
		`tazkirah-bm-5`,
	],
	prayerList: {
		// imsak: "Imsak",
		fajr: "Subuh",
		syuruk: "Syuruk",
		dhuhr: "Zohor",
		asr: "Asar",
		maghrib: "Maghrib",
		isha: "Isyak",
	},
	close: "Tutup",
	settings: "Penetapan",
	locationSelector: "Pilih lokasi",
	prayerTimeEstimate: "ke",
	changeLang: "Tukar bahasa",
	changeSettings: "Tukar tetapan",
	setDarkMode: "Pilih mod gelap",
	setMinimal: "Pilih mod minimal",
	// setLocation: "Pilih Lokasi",
	credit: "AA",
	subcredit: "kod di Malaysia",
	subcredit_extra: "Terima kasih barisan hadapan #covid19Malaysia",
	enableNotification: "Tunjuk notifikasi",
	currentPrayerTime: "Waktu solat sekarang",
};

export default bahasa;